import axios from 'axios';

import {
    menuRequest,
    menuSuccess,
    menuFail,
    clearError,
} from '../slices/menuSlice'

export const fetchMenu = () => async (dispatch) => {
    try {
        dispatch(menuRequest())
       const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/menu`);
        dispatch(menuSuccess(data))
    } catch (error) {
        //handle error
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(menuFail(message))
    }

}
